module.exports = __webpack_public_path__ + "img/cases-brand-vive-lazyload-41.d332e958.jpg";